export default __webpack_public_path__ + "static/media/P10016.d41d2070.png";